import React from 'react';
export function IntroContent() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-534">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-535">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
        borderColor: '#ede9e0'
      }} data-id="element-536">
          <p className="text-lg md:text-xl font-medium text-gray-900 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-537">
            Perfect for most any event from meetings, training classes, award
            luncheons to baby showers, graduations and especially wedding
            receptions or ceremonies.
          </p>
        </div>
      </div>
    </div>;
}